import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Emits `appLeaveFields` when focus leaves the host for somewhere outside it, so a tick/cross
 * value field can drop what was typed but not committed (the same as pressing the cross).
 *
 * Buttons inside the host do not take focus on mousedown: some browsers do not focus a clicked
 * button, which would read as leaving before the tick or cross gets its click.
 * Switching to another window is not leaving: the field keeps its value for when the user returns.
 */
@Directive({
	selector: '[appLeaveFields]',
})
export class LeaveFieldsDirective {
	@Output() readonly appLeaveFields = new EventEmitter<void>();

	constructor(private readonly host: ElementRef<HTMLElement>) {}

	@HostListener('mousedown', ['$event'])
	keepFocusOnButtons(event: MouseEvent): void {
		if ((event.target as HTMLElement | null)?.closest('button')) {
			event.preventDefault();
		}
	}

	@HostListener('focusout', ['$event'])
	leave(event: FocusEvent): void {
		const next = event.relatedTarget as Node | null;
		if (next && this.host.nativeElement.contains(next)) {
			return;
		}
		if (!next && !document.hasFocus()) {
			return;
		}
		this.appLeaveFields.emit();
	}
}
